import React, { useRef } from 'react';
import StudioCue, { StudioCueProps } from './StudioCue';
import StudioCueSlider from './StudioCueSlider';
import { Cue } from './Cue';
import { updateCue } from '../../store/CuesSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
  EventName,
  useEventsContext,
} from '../../context/events/EventsContext';

export interface StudioCueWrapperProps
  extends Omit<Cue, 'group' | 'description'>,
    Pick<StudioCueProps, 'isActive' | 'displayDivider' | 'showReset'> {}

const StudioCueWrapper = (props: StudioCueWrapperProps) => {
  const { type, label, SliderProps, isActive } = props;
  const { sliderLabels } = SliderProps;
  const { start, end } = sliderLabels;

  const { cueOptions } = useAppSelector(state => state.cues);
  const dispatch = useAppDispatch();

  const sliderValue = cueOptions[type] ?? 0;

  const [eventTracking] = useEventsContext();
  const previousValue = useRef<number>(sliderValue);
  const { projectId, actorId, variantId, ttsVersion } = useAppSelector(
    state => state.editor
  );
  const trackSliderUpdate = (newValue: number) => {
    if (previousValue.current === newValue) {
      return;
    }
    previousValue.current = newValue;

    eventTracking.track({
      type: EventName.CueSliderUpdated,
      data: {
        projectId: projectId || '',
        actorId: actorId || '',
        actorVariantId: variantId || '',
        ttsVersion: ttsVersion || '',
        cueType: type,
        value: newValue,
      },
    });
  };

  const onChange = (value: number) => {
    dispatch(updateCue({ items: [{ cueType: type, value: Number(value) }] }));
    trackSliderUpdate(value);
  };

  return (
    <StudioCue label={label}>
      <StudioCueSlider
        cueType={type}
        isActive={isActive}
        sliderValue={sliderValue}
        onChange={onChange}
        labels={{
          startLabel: start,
          endLabel: end,
        }}
      />
    </StudioCue>
  );
};

export default StudioCueWrapper;
